import { floor } from 'lodash';
import numeral from 'numeral';
import React, { Component } from 'react';
import './AvailableContribution.scss';
import If from '../../../Shared/If/If';
import { IRA_CONTRIBUTIONS_MODAL } from '../../../../redux/modules/modals/modals.module';
import CheckMark from '../../../Shared/CheckMark/CheckMark';
import { formatUnixDate } from '../../../../utils/dates/date-utility';
import { coalesce } from '../../../../utils/utils';
import iconInfo from '../../../../assets/images/icon_info.svg';
import exclamationIcon from '../../../../assets/images/exclamation.svg';

export class AvailableContribution extends Component {
  handleRefreshPage = () => {
    window.location.reload();
  };
  render() {
    const {
      amount,
      className,
      currentYear,
      displayTradeDate,
      fund,
      actions: { openModal },
      windowCutoffDate,
      iraLimitSearch,
    } = this.props;
    function showIRAContributions() {
      openModal(IRA_CONTRIBUTIONS_MODAL, {
        showSelectedYearOnlySmallVP: currentYear,
        fund,
      });
    }
    const flooredAmount = floor(amount, 2);
    const zeroRemain = flooredAmount === 0;
    const zeroStyles = zeroRemain
      ? `available-contribution-zero animated flipInX`
      : '';

    const year =
      formatUnixDate(displayTradeDate, 'YYYY') - (currentYear ? 0 : 1);

    if (iraLimitSearch && iraLimitSearch.hasFailed) {
      return (
        <span className={` ${coalesce(className, '')} available-contribution`}>
          <span className="available-contribution-amount-container">
            &nbsp;&nbsp;- -
          </span>

          <span
            className={`available-contribution-message ${zeroStyles} hidden-xs poa-error-container`}
          >
            <img src={exclamationIcon} alt="error" />
            <div className="error-text">
              <strong>
                <b>Error calculating contribution amount.</b>
              </strong>
              <br />
              Please <a onClick={this.handleRefreshPage}>refresh</a> the page.
            </div>
          </span>
        </span>
      );
    }

    return (
      <span className={` ${coalesce(className, '')} available-contribution`}>
        <span className="available-contribution-amount-container">
          {zeroRemain && (
            <CheckMark className="available-contribution-checkmark" />
          )}
          <span
            className={`available-contribution-amount ${zeroStyles} ${
              flooredAmount < 0 && 'available-contribution-negative'
            }`}
          >
            {numeral(flooredAmount).format('$0,0.00')}
          </span>
        </span>
        {flooredAmount === 0 ? (
          <span
            className={`available-contribution-message ${zeroStyles} hidden-xs`}
          >
            Great job! You’ve met the IRA annual contribution limit for {year}.{' '}
            <button
              onClick={showIRAContributions}
              tabIndex={0}
              className="available-buttons"
            >
              View Contribution Details
            </button>{' '}
            for more information.
          </span>
        ) : currentYear ? (
          <span
            className={`available-contribution-message ${zeroStyles} hidden-xs`}
          >
            Amount you can contribute.{' '}
            <button
              onClick={showIRAContributions}
              tabIndex={0}
              className="available-buttons"
            >
              View Contribution Details
            </button>{' '}
            for more information.
          </span>
        ) : (
          <span
            className={`available-contribution-message ${zeroStyles} hidden-xs`}
          >
            Amount you can contribute until your tax filing deadline.{' '}
            <button
              onClick={showIRAContributions}
              tabIndex={0}
              className="available-buttons"
            >
              View Contribution Details
            </button>{' '}
            for more information.
          </span>
        )}
        <a
          className="available-contributions-info-link visible-xs-inline-block"
          onClick={showIRAContributions}
          tabIndex={0}
        >
          <img
            className="available-contributions-info-icon"
            alt="icon"
            src={iconInfo}
          />
        </a>
        <If test={flooredAmount && !currentYear}>
          <div className="available-contribution-available-until-short visible-xs-block">
            (until {windowCutoffDate})
          </div>
        </If>
      </span>
    );
  }
}

export default AvailableContribution;
